import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import Dropdown from 'components/cosmos/dropdown';
import Tooltip from 'components/cosmos/tooltip';
import Icon from 'components/icons';
import { PageBadgeGroup } from 'components/moduleList/moduleItem/modulePageList/modulePage/pageBadgeGroup';
import { ReactComponent as DuplicateCosmos } from 'components/svg/icons/duplicate-sm.svg';
import { ReactComponent as EditCosmos } from 'components/svg/icons/edit-cosmos.svg';
import { ReactComponent as EllipsisVertical } from 'components/svg/icons/ellipsis-vertical.svg';
import { ReactComponent as ExternalLink } from 'components/svg/icons/external-link.svg';
import { ReactComponent as Trash } from 'components/svg/icons/trash.svg';
import { I18n, translate } from 'components/translate';
import { BASE_MODULE, ROUTES } from 'configs/routes/constants';
import { ClubWebSocketUtil } from 'helpers/clubWebSocket';
import { inject, PropTypes as MobxPropTypes } from 'mobx-react';
import DatahubPageService from 'modules/app/services/datahub/moduleList/datahubPageService';
import { CATEGORIES, ACTIONS } from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';
import { SeasonService } from 'modules/content';
import { getHotmartWebinarUrl } from 'modules/content/components/webinar/helpers';
import { ITEM_TYPE, PAGE_TYPES } from 'modules/content/constants';
import ContentPageService from 'modules/content/ContentPageService';
import ContentService from 'modules/content/ContentService';
import { FeatureToggles } from 'modules/featureToggle';
import MembershipService from 'modules/membership/MembershipService';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import DraggableContent from './DraggableContent';
import DropableService from './DropableService';
import PageCardDripping from './pageCardDripping';
import PageInfoMobile from './PageInfoMobile';

import ContentEvents from '../../events';
import { watchDuplicationStatus } from '../duplication/duplicationWebsocket';
import { clickAccessPanel } from '../webinar/LiveEvents';

@inject((stores) => ({
  onlineEvent: stores.MembershipStore.onlineEvent,
  liveMfeToggle: stores.LiveStore.mfeToggle,
  isDrippingByClassEnabled: stores.FeatureToggleStore.featureToggles.get(
    FeatureToggles.DrippingByClass
  )
}))
@translate()
class PageType extends Component {
  static propTypes = {
    item: PropTypes.object,
    index: PropTypes.number,
    checkedContent: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    isExtra: PropTypes.bool,
    isMobile: PropTypes.bool,
    closedDroppable: PropTypes.bool,
    isModuleDragging: PropTypes.bool,
    isPageDragging: PropTypes.bool,
    onMouseDown: PropTypes.func,
    onMouseUp: PropTypes.func,
    checkboxChange: PropTypes.func,
    isLast: PropTypes.bool,
    parentId: PropTypes.string,
    isPageChecked: PropTypes.func,
    onBlurPageNameHandler: PropTypes.func,
    pageHandleKeyPress: PropTypes.func,
    items: PropTypes.array,
    urlWithParams: PropTypes.func,
    showModalUnitPage: PropTypes.func,
    pageId: PropTypes.string,
    renderModalUnit: PropTypes.func,
    onlineEvent: PropTypes.bool,
    t: PropTypes.func,
    history: PropTypes.object,
    onReceiveDuplicationStatus: PropTypes.func,
    liveMfeToggle: MobxPropTypes.objectOrObservableObject
  };

  static defaultProps = {
    itemsLength: 0
  };

  shouldComponentUpdate(nextProps) {
    return (
      !DropableService.isItemsEqual(this.props.items, nextProps.items) ||
      !DropableService.isCheckedContentEqual(
        this.props.checkedContent,
        nextProps.checkedContent
      ) ||
      DropableService.isPageIdChanges(this.props.pageId, nextProps.pageId) ||
      nextProps.isMobile !== this.props.isMobile
    );
  }

  handleClickAccessPanel = (webinarKey) => {
    const { onlineEvent } = this.props;
    const url = getHotmartWebinarUrl(webinarKey, onlineEvent);

    window.open(url);
    clickAccessPanel();
    DatahubPageService.sendAccessPanelEvent();
  };

  renderWebinarAccessButton(webinarKey) {
    return (
      <div
        className="draggable-link"
        onClick={() => this.handleClickAccessPanel(webinarKey)}
      >
        <button className="hot-button hot-button--secondary hot-button--sm page-action-element">
          <ExternalLink className="_mr-2" />
          <I18n
            label="general.access_webinar_panel"
            className="page-action-element__label"
          />
        </button>
      </div>
    );
  }

  renderPageInfo(pageType, avgRating, totalComments, webinarKey) {
    const { isMobile } = this.props;
    const isContent = pageType === PAGE_TYPES.CONTENT;
    const isWebinar = pageType === PAGE_TYPES.WEBINAR;
    const classes = 'draggable__dripping__info page-content-info';

    if (isContent) {
      return (
        <div className={classes}>
          <div className="draggable-content-info__item">
            <Icon prefix="fal" iconName="comment-alt" />
            <p className="draggable-content-info__item__label _mt-0">
              {totalComments}
            </p>
          </div>
          <div className="draggable-content-info__item">
            <Icon prefix="fal" iconName="star" />
            <p className="draggable-content-info__item__label _mt-0">
              {avgRating && avgRating.toFixed(1)}
            </p>
          </div>
        </div>
      );
    }

    if (isWebinar) {
      return (
        <div className={classNames(classes, 'page-content-info--webinar')}>
          {!isMobile && this.renderWebinarAccessButton(webinarKey)}
        </div>
      );
    }

    return null;
  }

  renderPageDetails(item) {
    return (
      <div className="page-details">
        {this.renderPageInfo(item.type, item.avgRate, item.webinarKey)}
      </div>
    );
  }

  renderDraggableOptions = (item, type, draggablePageOptions) => {
    const { isMobile } = this.props;

    return (
      !isMobile && (
        <div className={`draggable-options ${type}-options`}>
          <div className={`draggable-actions ${type}-actions`}>
            {item.id && this.renderDraggablePageActions(draggablePageOptions)}
          </div>
        </div>
      )
    );
  };

  pageEditUrl(itemId, itemType, isExtra, parentId) {
    const { urlWithParams, liveMfeToggle } = this.props;
    const selectedSeason = MembershipService.hasSeason
      ? SeasonService.getSelectedSeasonInfo().id
      : null;

    const url =
      itemType === PAGE_TYPES.WEBINAR && liveMfeToggle.value
        ? ROUTES.CONTENT.EDIT_LIVE_MF.replace(':moduleId', parentId)
            .replace(':id', itemId)
            .replace('/', '')
        : `${BASE_MODULE}/${parentId}/${itemType.toLowerCase()}/${itemId}`;

    return urlWithParams(url, { extra: isExtra, season: selectedSeason });
  }

  goToVisualize = async (pageId) => {
    ContentEvents.sendPageEvent({ label: 'ViewPage' });
    DatahubPageService.sendContentPreviewEvent();
    ContentPageService.contentPreview(pageId);
  };

  onDuplicate = async (id) => {
    const { item, t, onReceiveDuplicationStatus } = this.props;
    const newName = `${t('general.copy_of')} ${item.name}`;
    const contextId = ClubWebSocketUtil.generateContextId();

    const response = await ContentService.duplicatePage({
      newName,
      page: id,
      contextId
    });

    if (response === false) {
      UiService.setAlertError('duplication_error', {});
      return;
    }

    watchDuplicationStatus({
      contextId,
      onReceive: onReceiveDuplicationStatus
    });

    const label = item.type;

    GtagService.sendClick({
      category: CATEGORIES.CLUB_ADMIN_CONTENT,
      where: ACTIONS.DUPLICATION_CONTENT.CONTENT,
      label
    });
    DatahubPageService.sendDuplicateEvent(label);
  };

  renderEditButton = (itemId, itemType, isExtra, parentId) => {
    const { liveMfeToggle, t, history } = this.props;

    const url = this.pageEditUrl(itemId, itemType, isExtra, parentId);

    const handleButtonClick = () => {
      liveMfeToggle.value && history.push(url);
    };

    let button = (
      <button
        className="hot-button hot-button--sm page-action-element"
        data-page-id={itemId}
        id={`edit-item-${itemId}`}
        onClick={handleButtonClick}
      >
        <EditCosmos className="edit-icon" />
      </button>
    );

    if (!liveMfeToggle.value) {
      button = (
        <Link to={url} onClick={this.onEdit}>
          {button}
        </Link>
      );
    }

    return (
      <Tooltip
        content={t('general.edit')}
        position={Tooltip.TOOLTIP_POSITION.TOP}
      >
        {button}
      </Tooltip>
    );
  };

  renderDraggablePageActions = ({ itemId, itemType, parentId, isExtra }) => {
    const { t } = this.props;
    const isWebinar = itemType === PAGE_TYPES.WEBINAR;

    return (
      <>
        <Tooltip
          content={t('general.visualize')}
          position={Tooltip.TOOLTIP_POSITION.TOP}
        >
          <button
            className="hot-button hot-button--sm page-action-element"
            onClick={() => this.goToVisualize(itemId)}
            data-page-id={itemId}
            id={`visualize-item-${itemId}`}
          >
            <ExternalLink />
          </button>
        </Tooltip>
        {this.renderEditButton(itemId, itemType, isExtra, parentId)}
        {!isWebinar && (
          <Tooltip
            content={t('general.duplicate')}
            position={Tooltip.TOOLTIP_POSITION.TOP}
          >
            <button
              className="hot-button hot-button--sm page-action-element"
              onClick={() => this.onDuplicate(itemId)}
              data-page-id={itemId}
              id={`duplicate-item-${itemId}`}
            >
              <DuplicateCosmos />
            </button>
          </Tooltip>
        )}
        <Tooltip
          content={t('general.exclude')}
          position={Tooltip.TOOLTIP_POSITION.TOP}
        >
          <button
            className="hot-button hot-button--sm page-action-element"
            onClick={() => this.onDelete(itemId)}
            id={`exclude-item-${itemId}`}
          >
            <Trash />
          </button>
        </Tooltip>
      </>
    );
  };

  onDelete = (id) => {
    const { showModalUnitPage } = this.props;

    ContentEvents.sendPageEvent({ label: 'RemovePage' });
    DatahubPageService.sendRemoveEvent();
    showModalUnitPage(id);
  };

  onEdit = () => {
    ContentEvents.sendPageEvent({ label: 'EditPage' });
    DatahubPageService.sendEditEvent();
  };

  onInputClick = (e) => {
    e.stopPropagation();
    ContentEvents.sendPageEvent({ label: 'EditTitle' });
    DatahubPageService.sendEditTitleEvent();
  };

  onCheckboxchange = (e) => {
    e.stopPropagation();

    const { checkboxChange, item } = this.props;

    ContentEvents.sendPageEvent({ label: 'CheckPage' });
    DatahubPageService.sendCheckEvent();

    checkboxChange && checkboxChange(e, item);
  };

  onMouseUp = (e) => {
    const { onMouseUp } = this.props;

    ContentEvents.sendPageEvent({ label: 'OrderPage' });

    DatahubPageService.sendOrderEvent();

    onMouseUp && onMouseUp(e);
  };

  renderDraggableContent() {
    const {
      item = {},
      index,
      checkedContent,
      isMobile,
      isExtra,
      onMouseDown,
      isModuleDragging,
      isPageDragging,
      closedDroppable,
      isPageChecked,
      onBlurPageNameHandler,
      pageHandleKeyPress,
      parentId,
      renderModalUnit,
      pageId,
      history
    } = this.props;

    const type = ITEM_TYPE.PAGE;
    const draggableClass = classNames(`draggable-${type}`);
    const draggableClassContent = classNames(draggableClass, {
      'draggable-page-invisible': closedDroppable
    });
    const isChecked = isPageChecked(item.id, parentId);
    const checkboxContentId = `checkbox-select-content_${item.id}`;
    const draggablePageOptions = {
      itemId: item.id,
      itemType: item.type,
      parentId,
      withLabel: isMobile,
      isExtra,
      index
    };

    return (
      <DraggableContent
        data-test="page-type-item"
        checkedContent={checkedContent}
        index={index}
        type={type}
        item={item}
        id={item.id}
        className={draggableClassContent}
        isModuleDragging={isModuleDragging}
        isPageDragging={isPageDragging}
        dragOnMouseUp={this.onMouseUp}
        dragOnMouseDown={onMouseDown}
        isExtra={isExtra}
      >
        <div className="page-header">
          {pageId === item.id && renderModalUnit(item.type, item.id)}
          <div className="content-list-name content-list-name--page _d-flex _align-items-start">
            <div className="hot-form hot-form--custom hot-form--checkbox">
              <input
                type="checkbox"
                className={`hot-form__input ${type}-checkbox`}
                id={checkboxContentId}
                checked={isChecked}
                onChange={this.onCheckboxchange}
                data-page={item.id}
                data-published={item.published}
              />
              <label className="hot-form__label" htmlFor={checkboxContentId} />
            </div>
            <input
              className="content-list-name-input"
              defaultValue={item.name}
              data-page={item.id}
              onBlur={onBlurPageNameHandler}
              onKeyPress={pageHandleKeyPress}
              onClick={this.onInputClick}
              maxLength="100"
            />
            {this.renderDraggableOptions(item, type, draggablePageOptions)}
            {isMobile && item.id && (
              <Dropdown data-test="dropdown">
                <button slot="button" data-test="button-ellipis-vertical">
                  <EllipsisVertical />
                </button>
                <PageInfoMobile
                  item={item}
                  actions={{
                    delete: () => this.onDelete(item.id),
                    edit: () => {
                      this.onEdit();
                      history.push(
                        this.pageEditUrl(item.id, item.type, isExtra, parentId)
                      );
                    },
                    visualize: () => this.goToVisualize(item.id),
                    webinar: () => this.handleClickAccessPanel(item.webinarKey),
                    duplicate: () => this.onDuplicate(item.id)
                  }}
                />
              </Dropdown>
            )}
          </div>
          <div className="draggable-info">
            <PageCardDripping
              drippingConfig={item.drippingConfig}
              drippingConfigsSize={item.drippingConfigsSize}
            />
            {this.renderPageInfo(
              item.type,
              item.avgRate,
              item.totalComments,
              item.webinarKey
            )}
            {this.renderPageDetails(item)}
          </div>
        </div>
        <PageBadgeGroup
          className="_mt-2"
          pageType={item.type}
          isPublished={item.published}
        />
      </DraggableContent>
    );
  }

  render() {
    return <>{this.renderDraggableContent()}</>;
  }
}

export { PageType };
export default withRouter(PageType);
